module.exports = __webpack_public_path__ + "static/media/Flag-Sudan.89a38371.svg";